import { getFormattedTimestamp } from '../../Utilities/TimeFunctions';

const buildModeratedCommentString = (date, moderationAction) =>
    `User ${moderationAction} comment on ${getFormattedTimestamp(date)}`;

export const getDeletedCommentString = (date) =>
    buildModeratedCommentString(date, 'deleted');

export const getEditedCommentString = (date) =>
    buildModeratedCommentString(date, 'edited');
